import { Session } from './http/api/sessions/sessions.types';

export const copySessionPublicLink = (session: Session): void => {
  if (session.is_hidden) {
    navigator.clipboard.writeText(`${window.location.origin}/public/sign-in?session=${session.id}`);
  } else {
    navigator.clipboard.writeText(`${window.location.origin}/public-session/${session.id}`);
  }
};
